import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import $ from 'jquery'
import { Base64 } from 'js-base64'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import GlobalHelper from '../common/GlobalHelper.jsx'
import { integrationKeyLightspeedEcom } from '../integration/IntegrationConstants.jsx'

const queryString = require('query-string')
const BadgePosition = 'bottomleft'
const SiteKey = '6Lc8pfUdAAAAAA21H34Qt_Y_uMtPbek2Eg4KleOX'
const GoogleReCaptchaUrl = 'https://www.google.com/recaptcha/api.js'

class SignIn extends Component {

    constructor(props, context) {
        super(props, context)
        this.handleFormChange = this.handleFormChange.bind(this)
        const uri = queryString.parse(this.props.location.search)
        const message = uri.m
        const autoLogin = uri.al
        if (uri.m) {
            delete uri.m
        }
        if (uri.al) {
            delete uri.al
        }
        if (!uri.response_type) {
            uri.response_type = 'code'
        }
        if (!uri.redirect_uri) {
            uri.redirect_uri = AppContext.getOptions().webCpqUrl + '/auth'
        }
        if (!uri.client_id) {
            const options = AppContext.getOptions()
            switch (options.environment) {
                case 'dev':
                    uri.client_id = 'web-cpq'
                    break
                case 'staging':
                    uri.client_id = 'staging-web-cpq'
                    break
                case 'release-candidate':
                    uri.client_id = 'rc-web-cpq'
                    break
                case 'prod':
                    uri.client_id = 'prod-web-cpq'
                    break
            }

        }

        this.state = {
            formUrl: AppContext.getOptions().apiUrl + '/authorize?' + queryString.stringify(uri),
            message: message || '',
            redirect: '',
            email: uri.em || '',
            password: '',
            autoLogin: autoLogin,
            uri: uri || '',
        }
    }

    componentDidMount() {
        const script = document.createElement('script')
        script.src = `${GoogleReCaptchaUrl}?badge=${BadgePosition}&render=${SiteKey}`
        document.body.appendChild(script)

        fetch('/session', {
            credentials: "same-origin"
        }).then(res => {
            if (res.status == 200) {
                window.location = '/'
            }
        })
        if (this.state.autoLogin) {
            const login = JSON.parse(Base64.decode(this.state.autoLogin))
            if (login.e && login.p) {
                this.setState({
                    email: login.e,
                    password: login.p,
                }, () => {
                    $('#login').submit()
                })
            }
        }
        this.setupIntercom()
    }


    setupIntercom() {
        window.Intercom("boot", {
            app_id: GlobalHelper.getIntercomAppId(),
        })
        window.intercomSettings = {
            app_id: GlobalHelper.getIntercomAppId(),
            app_environment: AppContext.getOptions().environment,
            language_override: AppContext.getLocale().language,
        }
        window.Intercom("update")
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit = async () => {
        const token = await window.grecaptcha.execute()
        if (!token) {
            this.setState({message: 'recaptcha_token_generation_error'})
            return
        }
        const form = document.getElementById('login')
        form.submit()
    }

    render() {
        let message = ''
        const signUpUrl = GlobalHelper.isEnvProduction() ? 'https://www.quotemachine.com/en/sign-up/' : '/p/signup/'
        const hasLightspeedEcomIntegration = (this.state.uri.integrationKey && [integrationKeyLightspeedEcom].includes(this.state.uri.integrationKey))
        switch (this.state.message) {
            case 'wrong_password':
                message = <div className="alert alert-danger" role="alert">
                    <FormattedMessage
                        id="sign_in.wrong_password_text"
                        defaultMessage="Wrong email or password!"
                    />
                </div>
                break
            case 'too_many_retries':
                message = <div className="alert alert-danger" role="alert">
                    <FormattedMessage
                        id="sign_in.too_many_retries_text"
                        defaultMessage="Your account has been blocked for 30 minutes"
                    />
                </div>
                break
            case "user_is_disabled":
                message = <div className="alert alert-danger" role="alert">
                    <FormattedMessage
                        id="sign_in.user_is_disabled"
                        defaultMessage="Your user is disabled. Please contact your account administrator."
                    />
                </div>
                break
            case "user_already_exists":
                message = <div className="alert alert-danger" role="alert">
                    <FormattedMessage
                        id="sign_in.user_already_exists"
                        defaultMessage="A user with the same email already exists."
                    />
                </div>
                break
            case "recaptcha_token_generation_error":
                message = <div className="alert alert-danger" role="alert">
                    <FormattedMessage
                        id="sign_in.recaptcha_token_error"
                        defaultMessage="An error has occurred. If this problem persists please contact support."
                    />
                </div>
                break
            case "recaptcha_validation_failure":
                message = <div className="alert alert-danger" role="alert">
                    <FormattedMessage
                        id="sign_in.recaptcha_validation_error"
                        defaultMessage="Captcha failed to validate. Please try again. If this problem persists please contact support."
                    />
                </div>
                break
        }

        return <div className="row ui-has-modules justify-content-md-center">
            {this.state.redirect}
            <div className="col-12 my-4">
                <h1 className="text-align-center">
                    <img src='/images/QuoteM_regular.png' height='80px'/>
                </h1>
            </div>
            <div className="col-md-6 col-lg-5 col-xl-4 ui-module">
                <div className="row">
                    <div className="col-12 text-center">
                        {message}
                        <form id='login' action={this.state.formUrl} method="POST">
                            <div className="form-group text-left">
                                <label htmlFor="inputEmail">
                                    <FormattedMessage
                                        id="sign_in.email_label"
                                        defaultMessage="Email address"
                                    />
                                </label>
                                <input name="email" id="inputEmail"
                                       onChange={this.handleFormChange}
                                       value={this.state.email}
                                       className="form-control"
                                       autoComplete="username"
                                       required autoFocus/>
                            </div>
                            <div className="form-group text-left">
                                <label htmlFor="inputPassword">
                                    <FormattedMessage
                                        id="sign_in.password_label"
                                        defaultMessage="Password"
                                    />
                                </label>
                                <input name="password"
                                       type="password"
                                       onChange={this.handleFormChange}
                                       value={this.state.password}
                                       id="inputPassword" autoComplete="current-password"
                                       className="form-control"
                                       required
                                />
                            </div>

                            <div
                                className={'g-recaptcha'}
                                data-sitekey={SiteKey}
                                data-size='invisible'
                            />

                            <button type="button"
                                    className="btn btn-primary col-12 mt-4"
                                    onClick={this.handleSubmit}>
                                <FormattedMessage
                                    id="sign_in.sign_in_btn"
                                    defaultMessage="Sign in"
                                />
                            </button>
                        </form>
                    </div>
                </div>
                <div className="row d-flex align-items-center pb-3 pt-3">
                    <div className="flex-grow-1"><hr /></div>
                    <span className="ml-2 mr-2 mt-1">
                        <strong>
                            <FormattedMessage
                                id="signup.or_label"
                                defaultMessage="OR"
                            />
                        </strong>
                    </span>
                    <div className="flex-grow-1"><hr /></div>
                </div>
                <div className="row justify-content-center mb-3">
                    <div className="col-md-12 col-12 justify-content-center d-flex" >
                        <a href={AppContext.getOptions().apiUrl + '/openid/signin/quick-books'}>
                            <img src={'/images/intuit_sign_in.svg'} width={'150px'}/>
                        </a>

                    </div>
                </div>
            </div>

            {/* {!hasLightspeedEcomIntegration &&
            <div className="col-12">
                <p className="text-align-center">
                    <a href={signUpUrl}>
                        <FormattedMessage
                            id="sign_in.no_account_yet"
                            defaultMessage="You don't have an account yet?"
                        />
                    </a>
                </p>
            </div>
            } */}
            <div className="col-12">
                <p className="text-align-center">
                    <Link to={'/p/forgot-password'}>
                        <FormattedMessage
                            id="sign_in.forgot_password"
                            defaultMessage="Forgot your password?"
                        />
                    </Link>
                </p>
            </div>
        </div>
    }

}

export default SignIn





// WEBPACK FOOTER //
// ./src/auth/signin.component.jsx